import React, { useEffect, useRef, useState } from 'react';

import { MetaTagHandler } from '../../../library/client/serverCallHandler';
import Footer from '../../components/footer';

import FaucetPromo from './faucetPromo';
// import { Link, Outlet, Route } from "react-router-dom";



const Faucet = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>

            <MetaTagHandler>
                {() => (
                    <>
                        <title>Faucet | PLURI</title>
                        <meta name="description" content="PLURI Faucet provides an easy-to-use platform to get free PLURI cryptocurrency. A simple way to start your journey in the PLURI ecosystem." />
                        <meta property="og:title" content="PLURI | Faucet" />
                        <meta property="og:description" content="PLURI Faucet provides an easy-to-use platform to get free PLURI cryptocurrency. A simple way to start your journey in the PLURI ecosystem." />
                        <meta property="og:image" content={`https://${process.env.REACT_APP_ORIGIN}/assets/pluriBanner.png`} />
                        <meta property="og:url" content={`https://${process.env.REACT_APP_ORIGIN}/faucet`} />
                        <meta property="og:site_name" content="PLURI" />
                        <meta property="og:type" content="website" />
                        <meta property="og:locale" content="en_US" />
                    </>
                )}
            </MetaTagHandler> 


            {/* <Outlet /> */}

            <FaucetPromo />


            <Footer /> 




        </>
    );
};

export default Faucet;
